import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { handleResponseThrowError } from '@/_utils/services';
import {
  GET_MONITOR_DELIVERY_DETAIL,
  MONITOR_REFETCH_INTERVAL,
} from '../constants';
import type { GetMonitorDeliveryDetailResponse } from '../types';

const getMonitorDeliveryDetail = (deliveryId: string) =>
  apiClient
    .get<GetMonitorDeliveryDetailResponse>(`/entregas/${deliveryId}/monitor`)
    .then(response => response.data)
    .catch(handleResponseThrowError());

type GetMonitorDeliveryDetailData = Awaited<
  ReturnType<typeof getMonitorDeliveryDetail>
>;

export const useMonitorDeliveryDetail = (
  deliveryId?: string,
  options: Omit<
    UseQueryOptions<
      GetMonitorDeliveryDetailData,
      unknown,
      GetMonitorDeliveryDetailData,
      (string | undefined)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) =>
  useQuery({
    queryKey: [GET_MONITOR_DELIVERY_DETAIL, deliveryId],
    queryFn: () => getMonitorDeliveryDetail(deliveryId as string),
    enabled: !!deliveryId,
    refetchInterval: MONITOR_REFETCH_INTERVAL,
    refetchIntervalInBackground: true,
    ...options,
  });
